import { render, staticRenderFns } from "./ti3.vue?vue&type=template&id=fa251b72&scoped=true&"
import script from "./ti3.vue?vue&type=script&lang=js&"
export * from "./ti3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa251b72",
  null
  
)

export default component.exports